import {enumType} from 'common/enumType';
import * as yup from 'common/yup';
import {CONTEXT_SEND_PARAMETER} from 'common/yup/constants';
import {isBoolean} from 'lodash';

export const userAction = enumType({
   LOCK: 'LOCK',
   DISABLE: 'DISABLE',
});

export const SftpAuthRulesNames = {
   _LOGINS_CHECK: 'AFTER_INVALID_LOGINS_CHECK',
   numInvalidLogins: 'numInvalidLogins',
   invalidLoginPeriod: 'invalidLoginPeriod',

   _LOCK_USER_ACTION: 'LOCK_OUT_USER_RADIO',
   lockoutPeriod: 'lockoutPeriod',

   // _: 'DISABLE_USER_RADIO',
   _DISABLE_USER_AFTER_CHECK: 'DISABLE_USER_AFTER_CHECK',
   inactivityLimit: 'inactivityLimit',

   _REQUIRE_PASSWORD_CHANGE_EVERY_CHECK: 'REQUIRE_PASSWORD_CHANGE_EVERY_CHECK',
   passwordChangeLimit: 'passwordChangeLimit',
} as const;
const SftpAuthRulesCore = yup.object({
   [SftpAuthRulesNames.numInvalidLogins]: yup.number(),
   [SftpAuthRulesNames.invalidLoginPeriod]: yup.number(),
   [SftpAuthRulesNames.lockoutPeriod]: yup.number(),
   [SftpAuthRulesNames.inactivityLimit]: yup.number(),
   [SftpAuthRulesNames.passwordChangeLimit]: yup.number(),
});

const _SftpAuthRulesToSend = SftpAuthRulesCore.transform(function (val, origin) {
   if (!isBoolean(val[SftpAuthRulesNames._LOGINS_CHECK])) {
      return val;
   }

   if (!val[SftpAuthRulesNames._LOGINS_CHECK]) {
      val[SftpAuthRulesNames.numInvalidLogins] = 0;
      val[SftpAuthRulesNames.invalidLoginPeriod] = 0;
      val[SftpAuthRulesNames.lockoutPeriod] = 0;
   }

   if (val[SftpAuthRulesNames._LOCK_USER_ACTION] === userAction.enum.DISABLE) {
      val[SftpAuthRulesNames.lockoutPeriod] = 0;
   }

   if (!val[SftpAuthRulesNames._DISABLE_USER_AFTER_CHECK]) {
      val[SftpAuthRulesNames.inactivityLimit] = 0;
   }
   if (!val[SftpAuthRulesNames._REQUIRE_PASSWORD_CHANGE_EVERY_CHECK]) {
      val[SftpAuthRulesNames.passwordChangeLimit] = 0;
   }

   delete val[SftpAuthRulesNames._LOGINS_CHECK];
   delete val[SftpAuthRulesNames._LOCK_USER_ACTION];
   delete val[SftpAuthRulesNames._DISABLE_USER_AFTER_CHECK];
   delete val[SftpAuthRulesNames._REQUIRE_PASSWORD_CHANGE_EVERY_CHECK];

   return val;
});

const _SftpAuthRulesWithHelpers = SftpAuthRulesCore.shape({
   [SftpAuthRulesNames._LOGINS_CHECK]: yup.boolean(),
   [SftpAuthRulesNames._LOCK_USER_ACTION]: yup.string().oneOf(userAction.keys),
   [SftpAuthRulesNames._DISABLE_USER_AFTER_CHECK]: yup.boolean(),
   [SftpAuthRulesNames._REQUIRE_PASSWORD_CHANGE_EVERY_CHECK]: yup.boolean(),
}).transform(function (val, origin) {
   if (isBoolean(val[SftpAuthRulesNames._LOGINS_CHECK])) {
      return val;
   }
   val[SftpAuthRulesNames._LOGINS_CHECK] = val[SftpAuthRulesNames.numInvalidLogins] > 0;
   val[SftpAuthRulesNames._LOCK_USER_ACTION] =
      val[SftpAuthRulesNames.lockoutPeriod] > 0 ? userAction.LOCK : userAction.DISABLE;
   val[SftpAuthRulesNames._DISABLE_USER_AFTER_CHECK] = val[SftpAuthRulesNames.inactivityLimit] > 0;
   val[SftpAuthRulesNames._REQUIRE_PASSWORD_CHANGE_EVERY_CHECK] =
      val[SftpAuthRulesNames.passwordChangeLimit] > 0;

   return val;
});

export const SftpAuthRules = SftpAuthRulesCore.when(CONTEXT_SEND_PARAMETER, {
   is: true,
   then: _SftpAuthRulesToSend,
   otherwise: _SftpAuthRulesWithHelpers,
}) as typeof _SftpAuthRulesWithHelpers;
export type ISftpAuthRules = yup.InferType<typeof _SftpAuthRulesWithHelpers>;
